async function usersPageLoader () {
  return fetch('https://jsonplaceholder.typicode.com/users')
}

export default usersPageLoader;
